const vi = {
  '赞助和游戏责任': 'Tài trợ và Trách nhiệm chơi game',
'产品': 'Sản phẩm',
'游戏': 'Trò chơi',
"announcement": 'Tham gia vào sự hồi hộp và trải nghiệm sự phấn khích của các trò chơi trực tuyến của chúng tôi ngay hôm nay! Khám phá một thế giới cơ hội, nơi niềm vui và phần thưởng chỉ quanh góc!',
'排名': 'Xếp hạng',
"更多的": "Thêm",
"拱廊": "Trò chơi Arcade",
"撞车游戏": "Trò chơi Crash",
"钓鱼游戏": "Trò chơi Câu cá",
"直播": "Trực tiếp",
"登录": "Đăng nhập",
"注册": 'Đăng ký',
"选择语言": 'Ngôn ngữ',
"介绍人": "Người giới thiệu",
"账号": "Tài khoản",
"密码": "Mật khẩu",
"确认密码": "Xác nhận mật khẩu",
"真实姓名": "Tên thật",
"手机号码": "Số điện thoại",
"取款密码": "Mật khẩu rút tiền",
"验证码": "Mã xác minh",
"请输入密码": "Vui lòng nhập mật khẩu",
"请输入验证码": "Vui lòng nhập mã xác minh",
"请输入账号": "Vui lòng nhập tài khoản",
"请重新获取验证码": "Vui lòng lấy lại mã xác minh",
"正在登录中": "Đang đăng nhập",
"网络异常,请稍后再试": "Lỗi mạng, vui lòng thử lại sau",
"账号名": "Tên tài khoản",
"余额": "Số dư",
"会员中心": "Thành viên",
"网上存款": "Nạp tiền trực tuyến",
"网上提款": "Rút tiền trực tuyến",
"退出": "Thoát",
"请再次输入密码": "Vui lòng nhập lại mật khẩu",
"请输入姓名": "Vui lòng nhập tên của bạn",
"请输入手机号": "Vui lòng nhập số điện thoại của bạn",
"请输入取款密码": "Vui lòng nhập mật khẩu rút tiền",
"正在注册中": "Đang đăng ký",
"确定": "Xác nhận",
"注册成功": "Đăng nhập thành công",
"热门优惠": "Ưu đãi phổ biến",
"首页": "Trang chủ",
"查看活动": "Xem hoạt động",
"正在获取活动列表": "Đang lấy danh sách hoạt động",
"暂无活动": "Hiện không có hoạt động nào",
"活动详情": "Chi tiết sự kiện",
"视讯直播": "Phát trực tiếp video",
"直播类型": "Loại phát trực tiếp",
"热门": "Phổ biến",
"推荐": "Đề xuất",
"最新": "Mới nhất",
"全部": "Tất cả",
"获取类型中": "Đang lấy loại",
"获取具体信息中": "Đang lấy thông tin cụ thể",
"开始": "Bắt đầu",
"正在获取资源": "Đang lấy tài nguyên",
"正在努力加载中": "Đang tải",
"电子": "Điện tử",
"大厅": "Sảnh",
"游戏类型": "Loại trò chơi",
"游戏标签": "Thẻ trò chơi",
"错误的类型": "Loại sai",
"返回首页": "Trang chủ",
"正在获取游戏列表": "Đang lấy danh sách trò chơi",
"暂无游戏": "Hiện không có trò chơi nào",
"当前未登录,请先登录": "Hiện chưa đăng nhập, vui lòng đăng nhập trước",
"联系我们": "Liên hệ chúng tôi",
"导航": "Điều hướng",
"配置文件信息": "Thông tin hồ sơ",
"常用功能": "Chức năng phổ biến",
"充值": "Nạp tiền",
"提现": "Rút tiền",
"功能列表": "Danh sách chức năng",
"交易": "Giao dịch",
"设置": "Cài đặt",
"修改登入密码": "Thay đổi mật khẩu đăng nhập",
"修改提现密码": "Thay đổi mật khẩu rút tiền",
"银行卡": "Thẻ ngân hàng",
"若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置": "Nếu bạn đã từng đăng nhập trang web qua số điện thoại hoặc mạng xã hội, vui lòng liên hệ với dịch vụ khách hàng để được hỗ trợ cài đặt",
"旧密码": "Mật khẩu cũ",
"请输入旧密码": "Vui lòng nhập mật khẩu cũ của bạn",
"设定新密码": "Đặt mật khẩu mới",
"确认新密码": "Xác nhận mật khẩu mới",
"确认": "Xác nhận",
"下一步": "Bước tiếp theo",
"交易功能": "Chức năng giao dịch",
"支付方式": "Phương thức thanh toán",
"充值教学": "Hướng dẫn nạp tiền",
"选择渠道": "Chọn kênh",
"存款金额": "Số tiền gửi",
"实际金额": "Số tiền thực tế",
"提现币种": "Loại tiền rút",
"提现银行卡": "Thẻ ngân hàng rút tiền",
"新增": "Thêm mới",
"提现金额": "Số tiền rút",
"提现金额范围": "Phạm vi số tiền rút",
"请输入金额": "Vui lòng nhập số tiền",
"实际到帐": "Số tiền thực nhận",
"一般手续费": "Phí xử lý thông thường",
  "强制手续费": "Phí xử lý bắt buộc",
  "上一步": "Quay lại",
  "修改成功": "Chỉnh sửa thành công",
  "修改中": "Đang chỉnh sửa",
  "拼命加载中": "Đang tải",
  "编辑登录密码": "Chỉnh sửa mật khẩu đăng nhập",
  "编辑提款密码": "Chỉnh sửa mật khẩu rút tiền",
  "如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。": "Nếu bạn đăng nhập vào trang web bằng số điện thoại hoặc nền tảng xã hội, vui lòng liên hệ với bộ phận chăm sóc khách hàng để được hỗ trợ.",
  "请输入新密码": "Vui lòng nhập mật khẩu mới",
  "新密码不能和旧密码一致": "Mật khẩu mới không được giống mật khẩu cũ",
  "两次输入密码不一致!": "Hai lần nhập mật khẩu không khớp!",
  "请输入提款密码": "Vui lòng nhập mật khẩu rút tiền",
  "输入提款密码": "Nhập mật khẩu rút tiền",
  "请设置新的提款密码": "Vui lòng đặt mật khẩu rút tiền mới",
  "设置6位提款密码，并记住您的密码": "Đặt mật khẩu rút tiền 6 chữ số và nhớ mật khẩu của bạn",
  "请输入新的提款密码": "Vui lòng nhập mật khẩu rút tiền mới",
  "存款": "Nạp tiền",
  "取款": "Rút tiền",
  "付款方式": "Phương thức thanh toán",
  "存款金额": "Số tiền nạp",
  "请输入金额": "Vui lòng nhập số tiền",
  "下一步": "Bước tiếp theo",
  "提款金额": "Số tiền rút",
  "提款银行卡": "Thẻ ngân hàng rút tiền",
  "请输入您的银行卡号": "Vui lòng nhập số thẻ ngân hàng của bạn",
  "切换语言将会刷新页面": "Chuyển ngôn ngữ sẽ làm mới trang",
  "充值方式": "Phương thức nạp tiền",
  "取消": "Hủy bỏ",
  "登录过期,是否重新登录": "Đăng nhập hết hạn, bạn có muốn đăng nhập lại không",
  "系统提示": "Thông báo hệ thống",
  "国家": "Quốc gia",
  "请输入": "Vui lòng nhập",
  "请选择": "Vui lòng chọn",
  "please-select-method": "Vui lòng chọn phương thức thanh toán",

  //新的一套
  "加载更多": "Tải thêm",
  "开始": "Chơi",
  // "存取款":"Deposit/Withdrawal",
  "存取款": "Nạp tiền",
  "加钱": "Thêm tiền",
  "选择您的奖金": "Chọn tiền thưởng của bạn",
  "100%,最高1500": "100% lên đến 1.500 R$",
  "CASINO": "CASINO",
  "Select your lottery": "Chọn xổ số của bạn",
  "don't want a lottery": "không muốn xổ số",
  "金额不得小于": "Số tiền không được nhỏ hơn",
  "金额不得大于": "Số tiền không được lớn hơn",
  "加载失败": "Tải thất bại",
  "活动中心": "Trung tâm sự kiện",
  "**财富攀升-BRL的充值促销**": "**Thăng Tiến Tài Sản - Khuyến Mãi Nạp BRL**",
  "在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。": "Trong sự kiện độc đáo này, chúng tôi mang đến cho bạn cơ hội vô tận để tích lũy tài sản. Dù bạn là người mới hay đã có kinh nghiệm, mỗi lần nạp tiền sẽ mang lại cho bạn những món quà và đặc quyền ở các cấp độ khác nhau.",
  "**青铜级别（青铜）**": "**Cấp Đồng (Đồng)**",
  "-重新加载的总金额：1.000-5.000 BRL": "- Tổng số tiền nạp lại: 1.000 - 5.000 BRL",
  "-礼品的比例从5%逐渐增加到10%": "- Tỷ lệ quà tặng tăng dần từ 5% lên 10%",
  "-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。": "- Khi bạn nạp tiền lần đầu tiên, bạn sẽ nhận được một món quà độc quyền. Cánh cửa dẫn đến sự giàu có đang mở. Mỗi lần nạp tiền thêm, bạn sẽ nhận được nhiều quà tặng hơn.",
  "**银级（银级）**": "**Cấp Bạc (Bạc)**",
  "-重新加载的总金额：5.001-15.000 BRL": "- Tổng số tiền nạp lại: 5.001 - 15.000 BRL",
  "-礼品的比例从10%逐渐增加到15%": "- Tỷ lệ quà tặng tăng dần từ 10% lên 15%",
  "-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！": "- Bạn đã đạt đến cấp độ Bạc và tài sản của bạn sẽ tiếp tục tăng. Nạp tiền càng nhiều, tỷ lệ quà tặng càng cao. Nạp thêm để kiếm thêm!",
  "**黄金级别（Gold）**": "**Cấp Vàng (Vàng)**",
  "-重新加载的总金额：15.001-30.000 BRL": "- Tổng số tiền nạp lại: 15.001 - 30.000 BRL",
  "-礼品的比例从15%逐渐增加到18%": "- Tỷ lệ quà tặng tăng dần từ 15% lên 18%",
  "-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。": "- Bạn đang trên con đường quý tộc giàu có. Khi trở thành thành viên Vàng, bạn sẽ nhận được nhiều quà tặng hào phóng hơn. Sự giàu có của bạn chắc chắn sẽ phát đạt.",
  "**白金级别（白金）**": "**Cấp Bạch Kim (Bạch Kim)**",
  "-随着冷却值的增加，会奖励更多的礼物": "- Khi giá trị làm mát tăng, sẽ có nhiều quà tặng hơn",
  "-重新加载的总金额：30.001-60.000 BRL": "- Tổng số tiền nạp lại: 30.001 - 60.000 BRL",
  "-礼品的比例从18%逐渐增加到20%": "- Tỷ lệ quà tặng tăng dần từ 18% lên 20%",
  "-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。": "- Ở cấp độ Bạch Kim, nạp tiền của bạn sẽ nhận được tỷ lệ quà tặng cao hơn. Khả năng quản lý tài chính của bạn sẽ trở nên xuất sắc và nhận được những phần thưởng dồi dào.",
  "**钻石级别（钻石）**": "**Cấp Kim Cương (Kim Cương)**",
  "-重新加载的总金额：60.001-100.000 BRL": "- Tổng số tiền nạp lại: 60.001 - 100.000 BRL",
  "-礼品比例最高，达到20%": "- Tỷ lệ quà tặng cao nhất, đạt 20%",
  "-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。": "- Đây là đỉnh cao của danh dự, là lựa chọn cuối cùng. Khi trở thành thành viên Kim Cương, bạn sẽ tận hưởng tỷ lệ quà tặng cao nhất, giúp tài sản của bạn tăng nhanh và giấc mơ tài chính của bạn sắp thành hiện thực.",
  "不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！": "Đừng bỏ lỡ cơ hội hiếm có này. Leo lên bậc thang giàu có, chứng kiến tài sản của bạn nhân lên gấp bội. Tham gia chương trình khuyến mãi bổ sung BRL “Thăng Tiến Tài Sản” của chúng tôi và đảm bảo sự hỗ trợ tốt nhất để đạt được các mục tiêu tài chính của bạn. Hành trình đến sự giàu có bắt đầu từ bạn, phần thưởng sẽ không ngừng tăng lên và thành công đang ở gần bạn!",
  "游戏记录": "Hồ sơ trò chơi",
  "交易记录": "Ghi chép giao dịch",
"提交": "Gửi",
"游戏品牌": "Thương hiệu trò chơi",
"游戏名称": "Tên trò chơi",
"下注时间": "Thời gian đặt cược",
"下注金额": "Số tiền đặt cược",
"输赢金额": "Số tiền thắng hoặc thua",
"上一页": "Trang trước",
"下一页": "Trang tiếp theo",
"申请时间": "Thời gian đăng ký",
"状态": "Trạng thái",
"法规与合作伙伴": "Quy định và Đối tác",
"为了注册本网站，用户必须接受一般条款和条件。如果条款和条件发生更新，现有用户可以选择在上述更新生效之前停止使用产品和服务，即在更新公布后至少两周。tambet911.com 由JajajEmmi B.V.运营，注册号为150790，地址为Abraham Mendez Chumaceiro Boulevard 03，Willemstad，Curacao。本网站由库拉索岛电子博彩公司许可和监管，许可证号为1668/JAZ。": "Để đăng ký trang web này, người dùng phải chấp nhận các điều khoản và điều kiện chung. Nếu các điều khoản và điều kiện được cập nhật, người dùng hiện tại có thể chọn ngừng sử dụng sản phẩm và dịch vụ trước khi cập nhật có hiệu lực, tức là ít nhất hai tuần sau khi cập nhật được thông báo. Tambet911.com được điều hành bởi JajajEmmi B.V. với số đăng ký 150790 và địa chỉ là Abraham Mendez Chumaceiro Boulevard 03, Willemstad, Curacao. Trang web này được cấp phép và quản lý bởi Công ty Game Điện tử Curacao với số giấy phép 1668/JAZ.",
'您可以使用用户名和密码登录': 'Bạn có thể đăng nhập bằng tên người dùng và mật khẩu',
'创建账户': 'Tạo tài khoản',
'银行信息': 'Thông tin ngân hàng',
'名称': 'Tên',
'时间': 'Thời gian',
'最小': 'Tối thiểu',
'最大': 'Tối đa',
'即时到账': 'Nhận ngay lập tức',
'选择银行': 'Chọn ngân hàng',
'银行账号': 'Số tài khoản ngân hàng',
'请输入银行账号': 'Vui lòng nhập số tài khoản ngân hàng',
'金额': 'Số tiền',
'支出': 'Chi trả',
'输入金额': 'Vui lòng nhập số tiền',
"暂无数据": "Hiện tại không có dữ liệu nào",
'获奖人': 'Người thắng giải',
'游戏榜': 'Bảng xếp hạng trò chơi',
'新游戏榜': 'Bảng xếp hạng trò chơi mới',
'热门游戏榜': 'Bảng xếp hạng trò chơi phổ biến',
'电子游戏': 'Trò chơi điện tử',
'主要余额': 'Số dư chính',
'历史记录': 'Lịch sử',
'付款名称': 'Tên thanh toán',
'费用': 'Chi phí',
'免费': 'Miễn phí',
'立即生效': 'Có hiệu lực ngay lập tức',
'银行选择': 'Chọn ngân hàng',
'银行账户': 'Tài khoản ngân hàng',
'充值金额': 'Số tiền nạp',
'收款名称': 'Tên nhận tiền',
'账号类型': 'Loại tài khoản',
'收账账号': 'Số tài khoản thu tiền',
'CPF号码': 'Số CPF',
'提现密码': 'Mật khẩu rút tiền',
'请输入名称': 'Vui lòng nhập tên',
'请选择类型': 'Vui lòng chọn loại',
'请输入CPF': 'Vui lòng nhập CPF',
'请输入提现金额': 'Vui lòng nhập số tiền rút',
'请输入正确的参数': 'Vui lòng nhập tham số đúng',
"收藏夹":"Yêu thích",
"敬请期待":"Sắp có",
"用户":"Người dùng",
"玩家":"Người chơi",
"时间":"Thời gian",
"赌场":"Sòng bạc",
"体育运动":"Thể thao",
"促销":"Khuyến mãi",
"支持/法律":"Hỗ trợ/Pháp lý",
"加入我们的社区":"Tham gia cộng đồng của chúng tôi",
"赌场主页":"Trang chủ sòng bạc",
"插槽":"Máy đánh bạc",
"现场赌场":"Sòng bạc trực tiếp",
"新版本":"Phiên bản mới",
"桌面游戏":"Trò chơi bàn",
"体育之家":"Nhà thể thao",
"会员俱乐部":"Câu lạc bộ VIP",
"优惠促销":"Khuyến mãi đặc biệt",
"赌博意识":"Ý thức về cờ bạc",
"常问问题":"Câu hỏi thường gặp",
"条款和条件":"Điều khoản và điều kiện",
"隐私政策":"Chính sách bảo mật",
"赞助和游戏责任":"Tài trợ và trách nhiệm trò chơi",
"页脚文本":"BetBlitz đặt mục tiêu đạt được sự thống trị toàn cầu trong lĩnh vực trò chơi và cá cược trực tuyến, tận dụng công nghệ blockchain tiên tiến và ưu tiên hàng đầu là sự hài lòng của khách hàng. Nguyên tắc cốt lõi của chúng tôi là sự tin cậy, trung thực và công bằng, hướng dẫn mọi nỗ lực của chúng tôi.",
"充电时间":"Thời gian nạp tiền",
"订单号":"Số đơn hàng",
"充值金额":"Số tiền nạp",
"充值方式":"Phương thức nạp tiền",
"地位":"Trạng thái",
  
  '负责任的博彩': 'Cờ bạc có trách nhiệm',
'快速链接': 'Liên kết nhanh',
'桌上游戏': 'Trò chơi bàn',
'二十一点': 'Blackjack',
'扑克': 'Poker',
'百家乐': 'Baccarat',
'掷骰子': 'Xí ngầu',
'奖金': 'Thưởng',
'赌场奖金': 'Thưởng sòng bạc',
'自由旋转': 'Quay miễn phí',
'免费投注': 'Cược miễn phí',
'信息': 'Thông tin',
"":"",

"老虎机游戏": "Trò chơi máy đánh bạc",
"赌场游戏": "Trò chơi sòng bạc",
"更多游戏": "Nhiều trò chơi hơn",
"搜索游戏": "Tìm kiếm trò chơi",
"特色提供商": "Nhà cung cấp nổi bật",
"Logout": "Đăng xuất",
"Personal Center": "Trung tâm cá nhân",
"Limit": "Giới hạn",
"MessageCenter": "Trung tâm tin nhắn",

'All': 'Tất cả',
'Arcade': 'Arcade',
'Bingo': 'Bingo',
'Card': 'Thẻ',
'Casino': 'Sòng bạc',
'Crash': 'Crash',
'Fish': 'Cá',
'Live': 'Trực tiếp',
'Lottery': 'Xổ số',
'Slot': 'Máy đánh bạc',
'Sports': 'Thể thao',
'Video Game': 'Trò chơi điện tử',

'cs-title': '24 GIỜ',
'cs-text': 'Dịch vụ khách hàng luôn sẵn sàng hỗ trợ và giải đáp thắc mắc.',
'cs-contact': 'Liên hệ',

'social-media': 'Mạng xã hội',
'contact-us': 'Liên hệ với chúng tôi qua các kênh sau',

'footer-line1': 'do điều hành',
'footer-line2': 'Địa chỉ đăng ký công ty',
'footer-line3': 'Sản phẩm này chỉ dành cho người dùng trên 18 tuổi và chỉ để giải trí',
'footer-line4': 'Trò chơi này chứa các giao dịch mua trong ứng dụng',
'footer-line5': 'Việc người chơi chơi hoặc thắng trong cờ bạc xã hội không có nghĩa là họ sẽ thắng trong cờ bạc bằng tiền thật và các trò chơi liên quan trong tương lai',

// Added Lines

'popup-message': 'Bạn có muốn tắt nhắc nhở không?',

'sign-in': 'Đăng nhập',
'password': 'Mật khẩu',
'confirm-password': 'Xác nhận mật khẩu',
'remember-me': 'Nhớ tôi',
'forgot-password': 'Quên mật khẩu',
"sign-in-note": "Bạn chưa có tài khoản?",
"register-note": "Đã có tài khoản?",
"register": "Đăng ký",

"popular": "Phổ biến",
"promotion": "Khuyến mãi",
"follow": "Theo dõi",
'search': 'Tìm kiếm',

'home': 'Trang chủ',
'deposit': 'Nạp tiền',
'withdraw': 'Rút tiền',
'profile': 'Hồ sơ',
'online-cs': 'Dịch vụ Khách hàng Trực tuyến',

"search-games": "Tìm kiếm trò chơi",
"search-results": "Kết quả tìm kiếm",

'Activity': 'Hoạt động',
'Rebates': 'Khuyến mãi',
'VIP': 'VIP',
'History': 'Lịch sử',
'Cover': 'Bìa',

'recharge-activity': 'Hoạt động nạp tiền',
'time': 'Thời gian',
'reward': 'Phần thưởng',
'deposit-value': 'Giá trị nạp',
'status': 'Trạng thái',
'reward-bonus-discription': "Nhận 10R$ miễn phí sau lần nạp đầu tiên 100R$.",
'invitaion-activity-discription': "Mời bạn bè và nhận 100R$ miễn phí.",
'daily-loss-activity-discription': "Hoàn tiền 8% hàng ngày",
'recharge-rebet-activity-discription': "Nhận 20% hoàn tiền miễn phí khi nạp 100R$ trong một giao dịch",
'user-not-eligible': "Bạn không đủ điều kiện nhận phần thưởng này",
'不符合领取资格': "Không đủ điều kiện nhận",
'reward-claimed': "Đã yêu cầu phần thưởng thành công!",
'没有符合资格的充值': 'Không có nạp tiền đủ điều kiện',

  'invitation-activity': 'Hoạt động mời',
'recharge-amount': 'Số tiền nạp',
'spin': 'Quay',
'bonus': 'Thưởng',
'invites': 'Lời mời',
"install-btn": "CÀI ĐẶT",

'daily-loss-relief-fund': 'Quỹ hỗ trợ thua lỗ hàng ngày',
'percent': 'Phần trăm',
"amount-loss": "Số tiền thua lỗ",

'recharge-rebate-activity': 'Hoạt động hoàn tiền nạp<br>',
'recharge-amount': 'Số tiền nạp',
'return-ratio': 'Tỷ lệ hoàn lại',
'return-amount': 'Số tiền hoàn lại',

'recharge-note1': 'Mỗi lần nạp 100 reais Brazil có thể tham gia sự kiện',
'recharge-note2': 'Mỗi lần nạp 100 reais Brazil hoặc hơn được tính riêng;',
'recharge-note3': 'Hoạt động này yêu cầu tối thiểu 5 lần số tiền nạp để nhận thưởng;',
'recharge-note4': 'Những ai không đạt tiêu chuẩn hoặc không hoàn thành việc nhận thưởng sau sự kiện sẽ không thể nhận thưởng lần nữa;',
'recharge-note5': 'Không tránh được việc gây thua lỗ, xin hãy hoàn thành nhiệm vụ trước hoặc nhận thưởng;',
'recharge-note6': 'Hoạt động này giới hạn trong hành vi hoạt động bình thường của chủ tài khoản và cấm sử dụng các phương tiện kỹ thuật như thuê, gian lận, bot, chơi trò chơi với các tài khoản khác nhau, chải ngược lẫn nhau, trọng tài, giao diện, giao thức, khai thác lỗ hổng và kiểm soát nhóm. Nếu không, thưởng sẽ bị hủy, bị trừ, bị khóa hoặc thậm chí bị đưa vào danh sách đen;',
'recharge-note7': 'Quyền giải thích tất cả các hoạt động cuối cùng thuộc về nền tảng này;',

'claim': 'Yêu cầu',

'lottery-wheel': 'Bánh xe xổ số',
'number-of-spin': 'Số lần quay',
'spin': 'Quay',

'upgrade-required': 'Cần nâng cấp',
'recharge': 'Nạp tiền',
'betting': 'Cá cược',
'Bonus': 'Thưởng',
'Notification': 'Thông báo',
'Announcement': 'Thông báo',
'Support': 'Hỗ trợ',
'level': 'Cấp',

'view-data': 'Xem dữ liệu',
'current-data': 'Dữ liệu hiện tại',
'last': 'Cuối cùng',
'days': 'ngày',
'event': 'Sự kiện',
'notes': 'Ghi chú',

'rebate-funds': 'Quỹ hoàn tiền',
'statement': 'Báo cáo',
'rebate': 'Hoàn tiền',

'platform-rebate': 'Hoàn tiền nền tảng',
'action': 'Hành động',
'type': 'Loại',
'amount': 'Số tiền',

'record': 'Ghi chép',
'recharge-method': 'Phương thức nạp',
'recharge-note': 'Nếu bạn gặp bất kỳ vấn đề nào, vui lòng liên hệ với chúng tôi!',
'withdrawal-note': 'Nếu bạn gặp bất kỳ vấn đề nào, vui lòng liên hệ với chúng tôi!',
'online-service': 'Dịch vụ trực tuyến',
'recharge-amount': 'Số tiền nạp',
'withdrawal': 'Rút tiền',
'online-withdrawal': 'Rút tiền trực tuyến',
'withdrawal-method': 'Phương thức rút tiền',
'fee': 'Phí',
'full-name': 'Họ và tên',
'please-enter-your': 'Vui lòng nhập',
'name': 'Tên',
'collection-account-number': 'Số tài khoản thu',
'withdraw-password': 'Mật khẩu rút tiền',
'phone-number': 'Số điện thoại',
'security-center': 'Trung tâm bảo mật',
'change-password': 'Đổi mật khẩu',
'financial-status': 'Tình trạng tài chính',
'verify-password': 'Xác minh mật khẩu',
'bind-email-note': 'Bạn đang liên kết email và cần xác minh mật khẩu đăng nhập của mình',
'bind-password-note': 'Bạn đang thay đổi mật khẩu và cần đăng nhập để xác minh mật khẩu',
'next-step': 'Bước tiếp theo',

'balance': 'Số dư',
'information-center': 'Trung tâm thông tin',
'order-center': 'Trung tâm đơn hàng',
'agency-center': 'Trung tâm đại lý',
'exit': 'Thoát',
'bonus-amount': 'Số tiền thưởng',
'fee-amount': 'Số tiền phí',
'change': 'Thay đổi',
'male': 'Nam',
'female': 'Nữ',
'submit': 'Gửi',
'information': 'Thông tin',
'Details': 'Chi tiết',
'Fee': 'Phí',
'Association': 'Hiệp hội',

  'Invite': 'Mời',
'Agent': 'Đại lý',
'Invitation record': 'Ghi chép lời mời',
'Invitation': 'Lời mời',
'Reward': 'Thưởng',
'Agency mechanism': 'Cơ chế đại lý',
'Register subordinates': 'Đăng ký cấp dưới',
'my-id': 'ID của tôi',
'inviter-id': 'ID người mời',
'ordinary-agent': 'Đại lý thông thường',
'my-invitation-information': 'Thông tin lời mời của tôi',
'my-links': 'Liên kết của tôi',
'save-qr-code': 'Lưu mã QR',
'my-invitation-record': 'Ghi chép lời mời của tôi',
'total-number-of-invited-people': 'Tổng số người được mời',
'direct-reports': 'Báo cáo trực tiếp',
'invitation-rewards': 'Thưởng lời mời',
'invitation-total-reward': 'Tổng thưởng lời mời',
'directly-invite-rewards': 'Thưởng mời trực tiếp',
'indirect-invitation-reward': 'Thưởng mời gián tiếp',
'more': 'Thêm',

'invitation-total': 'Tổng lời mời',
'direct-rewards': 'Thưởng trực tiếp',
'indirect-incentives': 'Khuyến khích gián tiếp',
'no-agent': 'Không có đại lý để hiển thị',
"no-record": "Không tìm thấy ghi chép nào",
"no-more-roll": "Không còn lượt quay nào",
'rebate-ration': 'Tỷ lệ hoàn tiền',
'deposit-value': 'Giá trị nạp',

'bet-on': 'Cá cược',
'settlement': 'Giải quyết',
'consumption': 'Tiêu thụ',
'agent-text': 'Văn bản đại lý',
'reg-sub-text': "Sau khi hoàn thành đăng ký, nhập số điện thoại đã đăng ký của người được mời, mã mời và UID của họ để liên kết.",
'your-invitation-code': 'Mã lời mời của bạn',
'UID-of-the-invitee': 'UID của người được mời',
'user-does-not-exist': 'NGƯỜI DÙNG KHÔNG TỒN TẠI',

'no-record': 'Không tìm thấy ghi chép nào',
'reg-success': 'Đăng ký của bạn đã hoàn thành thành công',
'reg-failed': 'Đăng ký không thành công',
'valid-number': 'Vui lòng nhập số điện thoại di động hợp lệ',
'valid-pass2': 'Mật khẩu không khớp',
'pass-error': 'Mật khẩu phải có ít nhất 6 ký tự',
"network-error": "Lỗi mạng, vui lòng thử lại sau",
'fix-error': 'Vui lòng sửa lỗi trong biểu mẫu',

'invalid_phone': 'Vui lòng nhập số điện thoại di động chính xác.',
}
export default vi



// WEBPACK FOOTER //
// ./src/utils/lang/config/vi.js